export const codeErrors = {
  NETWORK_REQUEST_FAILED:
    'Verique sua conexão com a internet e tente novamente.',
  AUTH_INTERNAL_ERROR: 'Verique sua conexão com a internet e tente novamente.',
  AUTH_USER_NOT_FOUND: 'Não foi encontrada um conta para este e-mail.',
  AUTH_EMAIL_ALREADY_IN_USE: 'Esse e-mail já está em uso',
  AUTH_WRONG_PASSWORD: 'A senha está incorreta',
};
